export default __webpack_public_path__ + "static/media/bluescore.1e9bb448.webp";